
import { Button } from "@/components/ui/button";
import { Check, Trash2 } from "lucide-react";

interface AdminReviewActionsProps {
  onDelete: () => void;
  onDismiss: () => void;
  isDeleting: boolean;
  isMobile: boolean;
}

export const AdminReviewActions = ({
  onDelete,
  onDismiss,
  isDeleting,
  isMobile
}: AdminReviewActionsProps) => {
  return (
    <div className="flex justify-center gap-4">
      <Button
        variant="destructive"
        onClick={onDelete}
        className={`${isMobile ? 'w-full' : 'min-w-[140px]'}`}
      >
        <Trash2 className="h-4 w-4 mr-2" />
        Delete Review
      </Button>
      <Button
        className={`bg-green-600 hover:bg-green-700 ${isMobile ? 'w-full' : 'min-w-[140px]'}`}
        onClick={onDismiss}
      >
        <Check className="h-4 w-4 text-[#F2FCE2] mr-2" />
        Pass Review
      </Button>
    </div>
  );
};
